import { UserSwitch, X } from '@phosphor-icons/react';

export const ImpersonationBanner = () => {
  const isImpersonating = localStorage.getItem('cliniqueo_impersonating') === 'true';
  if (!isImpersonating) return null;

  const originalUser = JSON.parse(localStorage.getItem('cliniqueo_original_user') || '{}');
  const currentOrg = JSON.parse(localStorage.getItem('cliniqueo_organisation') || '{}');

  const exitImpersonation = () => {
    const originalToken = localStorage.getItem('cliniqueo_original_token');
    const originalUserData = localStorage.getItem('cliniqueo_original_user');
    const originalOrg = localStorage.getItem('cliniqueo_original_org');

    if (originalToken) {
      localStorage.setItem('cliniqueo_token', originalToken);
      localStorage.setItem('cliniqueo_user', originalUserData);
      localStorage.setItem('cliniqueo_organisation', originalOrg);
    }
    localStorage.removeItem('cliniqueo_impersonating');
    localStorage.removeItem('cliniqueo_original_token');
    localStorage.removeItem('cliniqueo_original_user');
    localStorage.removeItem('cliniqueo_original_org');
    window.location.href = '/platform';
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium" data-testid="impersonation-banner">
      <UserSwitch size={18} />
      <span>Impersonating <strong>{currentOrg?.name || 'Unknown Clinic'}</strong></span>
      <button
        onClick={exitImpersonation}
        className="ml-2 px-2 py-0.5 rounded bg-white/20 hover:bg-white/30 flex items-center gap-1 transition-colors"
        data-testid="exit-impersonation-btn"
      >
        <X size={14} /> Exit
      </button>
    </div>
  );
};
